var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffce47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9356"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 298.314,
    x2: 426.612,
    xlinkHref: "#lg1",
    y1: 354.031,
    y2: 482.33
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 121.541,
    x2: 270.888,
    xlinkHref: "#lg1",
    y1: 311.585,
    y2: 460.932
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    y1: 181.317,
    y2: 244.245
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9356"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff755c"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#843561",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3a2f4d"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg2",
    y1: 178.117,
    y2: 250.644
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9356",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff755c"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 323.733,
    x2: 251.744,
    xlinkHref: "#lg3",
    y1: 442.815,
    y2: 270.039
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 89.661,
    x2: 215.554,
    xlinkHref: "#lg1",
    y1: 258.636,
    y2: 384.53
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 333.046,
    x2: 422.638,
    xlinkHref: "#lg1",
    y1: 243.492,
    y2: 345.883
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 96.137,
    x2: 96.137,
    xlinkHref: "#lg1",
    y1: 98.836,
    y2: 191.315
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 413.863,
    x2: 413.863,
    y1: 80.348,
    y2: 135.099
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff755c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff4181"
  }))), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 159.509,
    x2: 159.509,
    y1: 87.459,
    y2: 211.925
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e4e08e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6fa953"
  }))), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 350.491,
    x2: 350.491,
    y1: 118.745,
    y2: 232.303
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff4181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#843561"
  }))), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    y1: 64.705,
    y2: 189.139
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7acbff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45a2e0"
  }))), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 128.227,
    x2: 128.227,
    xlinkHref: "#lg3",
    y1: 179.184,
    y2: 225.629
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 189.244,
    x2: 189.244,
    y1: 173.318,
    y2: 266.656
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#43765a",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43765a"
  }))), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    y1: 177.051,
    y2: 310.454
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#174461",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#174461"
  }))), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 320.756,
    x2: 320.756,
    xlinkHref: "#lg2",
    y1: 198.947,
    y2: 244.782
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 381.773,
    x2: 381.773,
    xlinkHref: "#lg2",
    y1: 174.384,
    y2: 253.356
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m429.903 209.158-153.761 88.12c-13.096 7.505-29.188 7.505-42.284 0l-153.761-88.12c-4.883 8.375-7.561 18.036-7.561 28.039v144.396c0 10.003 2.678 19.664 7.561 28.039 4.857 8.375 11.867 15.437 20.53 20.426l126.596 72.539c8.612 4.935 18.194 7.403 27.777 7.403 9.609 0 19.191-2.468 27.803-7.403l126.569-72.539c8.69-4.988 15.674-12.051 20.53-20.426 4.883-8.375 7.561-18.036 7.561-28.039v-144.396c.001-10.002-2.677-19.664-7.56-28.039z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m233.858 297.279-153.761-88.12c-4.883 8.375-7.561 18.036-7.561 28.039v144.396c0 10.003 2.678 19.664 7.561 28.039 4.857 8.375 11.867 15.437 20.53 20.426l126.596 72.539c8.612 4.934 18.194 7.402 27.777 7.402v-207.093c-7.297 0-14.594-1.876-21.142-5.628z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m429.903 209.158-174.903 100.237-174.903-100.237c9.045-5.717 147.126-92.965 147.126-92.965 17.196-9.871 38.357-9.871 55.579 0 .001.001 138.458 87.507 147.101 92.965z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m429.903 209.158-174.903 100.237-174.903-100.237c8.551-5.41 147.126-92.965 147.126-92.965 17.196-9.871 38.357-9.871 55.579 0 .001.001 138.392 87.473 147.101 92.965z",
    fill: "url(#SVGID_4_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m437.469 237.202v144.392c0 10.004-2.688 19.668-7.562 28.04-4.864 8.373-11.85 15.433-20.531 20.425l-126.57 72.537c-8.618 4.938-18.196 7.402-27.805 7.402-.725 0-1.461-.011-2.186-.053l-180.284-180.282v-92.461c0-10.004 2.688-19.667 7.562-28.04l174.907 100.233 174.907-100.233c4.874 8.373 7.562 18.036 7.562 28.04z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255 309.398-69.525 69.525c-5.801 5.801-14.77 6.997-21.888 2.918l-151.788-86.979c-5.572-3.193-6.588-10.808-2.047-15.35l70.341-70.351z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255 309.398 69.525 69.525c5.801 5.801 14.77 6.997 21.888 2.918l151.789-86.978c5.572-3.193 6.588-10.808 2.047-15.35l-70.341-70.351z",
    fill: "url(#SVGID_7_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m135.041 85.288-41.093-85.288h-33.2c-20.194 0-31.867 22.904-20 39.244l26.773 36.866c25.148 34.628 38.692 76.326 38.692 119.123v28.886l50.076 28.699v-68.928c0-35.424-7.438-69.94-21.248-98.602z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m449.252 0h-33.2l-41.093 85.288c-13.81 28.663-21.248 63.178-21.248 98.602v68.928l50.076-28.699v-28.886c0-42.797 13.544-84.495 38.693-119.123l26.773-36.865c11.867-16.341.194-39.245-20.001-39.245z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m225.07 183.89c0-35.424-2.255-69.939-6.443-98.602l-12.459-85.288h-112.22l41.093 85.288c13.81 28.663 21.248 63.178 21.248 98.602v68.928l68.781 39.42z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m374.959 85.288 41.093-85.288h-112.22l-12.46 85.288c-4.187 28.663-6.443 63.178-6.443 98.602v108.348l68.781-39.42v-68.928c.001-35.424 7.439-69.94 21.249-98.602z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m284.93 183.89c0-35.424 2.255-69.939 6.443-98.602l12.459-85.288h-97.664l12.46 85.288c4.187 28.663 6.443 63.178 6.443 98.602v108.348l29.929 17.153 29.93-17.153z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m106.213 195.232v28.886l50.076 28.699v-68.927c0-12.788-.984-25.452-2.872-37.771h-53.253c3.989 15.971 6.049 32.458 6.049 49.113z",
    fill: "url(#SVGID_13_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m156.289 183.89v68.928l68.781 39.42v-108.348c0-12.788-.298-25.452-.871-37.771h-70.782c1.888 12.318 2.872 24.983 2.872 37.771z",
    fill: "url(#SVGID_14_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m224.199 146.119c.573 12.319.871 24.983.871 37.771v108.348l29.93 17.153 29.93-17.153v-108.348c0-12.788.298-25.452.871-37.771z",
    fill: "url(#SVGID_15_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m285.801 146.119c-.573 12.319-.871 24.983-.871 37.771v108.348l68.781-39.42v-68.928c0-12.788.984-25.452 2.872-37.771z",
    fill: "url(#SVGID_16_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m356.583 146.119c-1.888 12.319-2.872 24.983-2.872 37.771v68.928l50.076-28.699v-28.886c0-16.656 2.061-33.143 6.049-49.114z",
    fill: "url(#SVGID_17_)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBox);
export default __webpack_public_path__ + "static/media/icon-box.b1f7bd7df00cefd4c72b50691019ad44.svg";
export { ForwardRef as ReactComponent };